import React from 'react';
import FallbackUI from './components/FallbackUI';

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const message = error && error.message ? error.message : '';
    const name = error && error.name ? error.name : '';

    const isChunkError =
      message.includes('Loading CSS chunk') ||
      message.includes('Loading chunk') ||
      message.includes('ChunkLoadError') ||
      name === 'ChunkLoadError';

    if (isChunkError) {
      try {
        const alreadyReloaded = sessionStorage.getItem('chunk-reload-done');
        if (!alreadyReloaded) {
          sessionStorage.setItem('chunk-reload-done', 'true');
          window.location.reload();
        }
      } catch (e) {
        window.location.reload();
      }
      return;
    }

    if (process && process.env && process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('Non-chunk error caught in ChunkErrorBoundary:', error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <FallbackUI
          resetError={() => this.setState({ hasError: false })}
        />
      );
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
